import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import ObjectViewer from '../Common/ObjectViewer';
import { parseJSON } from '../../utils/helpers';

const PendingDuplication = () => {
  const dispatch = useDispatch();
  const { pending_id } = useParams();

  const [showOriginalAdDetailsClicked, setShowOriginalAdDetailsClicked] = useState(undefined);
  const [objectViewrType, setObjectViewrType] = useState(undefined);

  const { pendingDuplication, showObjectViewr } = useSelector((state) => state.general);
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'pendingDuplication',
        route: 'pendingDuplications/getPendingDuplicationById',
        id: pending_id,
      })
    );
  }, [dispatch, pending_id]);
  console.log({ pendingDuplication });
  return pendingDuplication?._id ? (
    <div data-aos='fade-up' data-aos-delay='200'>
      <div className='container'>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-lg-12 d-flex justify-content-center border-bottom'>
            <h1>
              Pending Duplication: <span className='text-primary'>{pendingDuplication._id}</span>
            </h1>
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4 border-bottom'>
          <div className='col-lg-12 d-flex justify-content-center'>
            <h4>Object Viewer</h4>
          </div>
          <div className='col-lg-12 d-flex justify-content-center'>
            <small>Click to view object detials</small>
          </div>
          <div className='col-lg-12 d-flex justify-content-center mb-2 mt-4'>
            <button
              className={`btn btn-sm btn${objectViewrType === 'ORIGINAL_CAMPAIGN' ? '' : '-outline'}-primary`}
              onClick={() => {
                dispatch(
                  generalSet({
                    reduxField: 'showObjectViewr',
                    value: parseJSON(pendingDuplication?.campaignFromFB) || {},
                  })
                );
                setObjectViewrType('ORIGINAL_CAMPAIGN');
              }}
            >
              Original Campaign
            </button>
          </div>

          {showObjectViewr ? (
            <div className='row d-flex justify-content-center mb-4 '>
              <ObjectViewer data={showObjectViewr} />
              <div className='col-md-12 d-flex justify-content-center'>
                <button
                  className='btn btn-sm btn-outline-dark mb-4'
                  onClick={() => dispatch(generalSet({ reduxField: 'showObjectViewr', value: null }))}
                >
                  Hide Details
                </button>
              </div>
            </div>
          ) : null}
        </div>
        <div className=' mt-4'>
          {(() => {
            const adsPending = parseJSON(pendingDuplication.adsPending);
            console.log({ adsPending });
            if (!Array.isArray(adsPending)) {
              return (
                <div className='alert alert-danger' role='alert'>
                  No Ads Pending
                </div>
              );
            }
            return (
              <>
                <div className='col-md-12 d-flex justify-content-center'>
                  <h3>Pending Ads</h3>
                </div>
                {adsPending.map((adData) => {
                  const { ad, duplicateAdSpecsData, payloadForAd } = adData;
                  return (
                    <div key={ad.id} className='col-md-12'>
                      <div className='card'>
                        <div className='card-body'>
                          <h5 className='card-title'>
                            <span> Original Ad ID: {ad.id} </span>
                          </h5>
                          {ad.id === showOriginalAdDetailsClicked ? (
                            <>
                              <ObjectViewer data={ad} />
                              <div className='col-md-12 d-flex justify-content-center'>
                                <button
                                  className='btn btn-sm btn-outline-dark mb-4'
                                  onClick={() => setShowOriginalAdDetailsClicked('')}
                                >
                                  Hide Ad Details
                                </button>
                              </div>
                            </>
                          ) : (
                            <button
                              className='btn btn-sm btn-outline-primary'
                              onClick={() => setShowOriginalAdDetailsClicked(ad.id)}
                            >
                              Show Original Ad Details
                            </button>
                          )}

                          <p className='card-text mt-2'>
                            <b>Name: </b> {ad.name}
                          </p>
                          <div className='row d-flex justify-content-center'>
                            <div className='col-md-6 border p-2'>
                              <span className='mr-2'>
                                <b>Manual Creative ID</b>
                              </span>
                              <div>
                                <input type='text' className='form-control' placeholder='Creative ID...' />
                              </div>
                            </div>
                            <div className='col-md-6 border p-2'>
                              <span className='mr-2'>
                                <b> Creative ID From API</b>
                              </span>
                              <div>
                                <input type='text' className='form-control' placeholder='Creative ID...' />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            );
          })()}
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        {(() => {
          const data = {
            ...pendingDuplication,
            adsFromFB: parseJSON(pendingDuplication.adsFromFB),
            adsPending: parseJSON(pendingDuplication.adsPending),
            adsetCreationResponse: parseJSON(pendingDuplication.adsetCreationResponse),
            adsetFromFB: parseJSON(pendingDuplication.adsetFromFB),
            campaignCreationResponse: parseJSON(pendingDuplication.campaignCreationResponse),
            campaignFromFB: parseJSON(pendingDuplication.campaignFromFB),
            row: parseJSON(pendingDuplication.row),
          };
          return (
            <>
              <ObjectViewer data={data} />
            </>
          );
        })()}
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default PendingDuplication;
